export const GET_LIST = 'getList'
export const SET_LIST = 'setList'
